import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ruCommon from './locales/ru/common'
import enCommon from './locales/en/common'
import ruAuth from './locales/ru/auth'
import enAuth from './locales/en/auth'
import ruLanding from './locales/ru/landing'
import enLanding from './locales/en/landing'
import ruWorkspace from './locales/ru/workspace'
import enWorkspace from './locales/en/workspace'
import ruSettings from './locales/ru/settings'
import enSettings from './locales/en/settings'
import ruOrganization from './locales/ru/organization'
import enOrganization from './locales/en/organization'
import ruDemo from './locales/ru/demo'
import enDemo from './locales/en/demo'
import ruPricing from './locales/ru/pricing'
import enPricing from './locales/en/pricing'
import ruIntegrations from './locales/ru/integrations'
import enIntegrations from './locales/en/integrations'
import ruSolutions from './locales/ru/solutions'
import enSolutions from './locales/en/solutions'
import ruSecurity from './locales/ru/security'
import enSecurity from './locales/en/security'
import ruAgents from './locales/ru/agents'
import enAgents from './locales/en/agents'
import ruAutomations from './locales/ru/automations'
import enAutomations from './locales/en/automations'
import ruContextAudit from './locales/ru/context-audit'
import enContextAudit from './locales/en/context-audit'
import ruGtm from './locales/ru/gtm'
import enGtm from './locales/en/gtm'
import { DEFAULT_LANGUAGE, isLiveLanguage } from './supported-languages'

const LANGUAGE_STORAGE_KEY = 'ui-language'

function getInitialLanguage(): string {
  try {
    const stored = globalThis.localStorage.getItem(LANGUAGE_STORAGE_KEY)
    if (isLiveLanguage(stored)) return stored
  } catch {
    // Node / non-browser hosts may expose a non-functional localStorage.
  }
  return DEFAULT_LANGUAGE
}

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      common: ruCommon,
      auth: ruAuth,
      landing: ruLanding,
      workspace: ruWorkspace,
      settings: ruSettings,
      organization: ruOrganization,
      demo: ruDemo,
      pricing: ruPricing,
      integrations: ruIntegrations,
      solutions: ruSolutions,
      security: ruSecurity,
      agents: ruAgents,
      automations: ruAutomations,
      contextAudit: ruContextAudit,
      gtm: ruGtm,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      landing: enLanding,
      workspace: enWorkspace,
      settings: enSettings,
      organization: enOrganization,
      demo: enDemo,
      pricing: enPricing,
      integrations: enIntegrations,
      solutions: enSolutions,
      security: enSecurity,
      agents: enAgents,
      automations: enAutomations,
      contextAudit: enContextAudit,
      gtm: enGtm,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: 'common',
  ns: [
    'common',
    'auth',
    'landing',
    'workspace',
    'settings',
    'organization',
    'demo',
    'pricing',
    'integrations',
    'solutions',
    'security',
    'agents',
    'automations',
    'contextAudit',
    'gtm',
  ],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export { LANGUAGE_STORAGE_KEY }
export default i18n
